<template>
    <div class="container">
        <el-button type="primary"  style="width: 120px;height: 40px;margin: 20px" class="btnColor" @click="addCate(1,0)">添加一级分类</el-button>
        <el-col :span="18">
            <ul class="parent">
                <li v-for="items in cateData">
                    <div>
                        <span>{{items.name}}</span>
                        <el-button type="text" @click="del(items.id)">删除</el-button>
                        <el-button type="text" @click="edit(items.id)">修改</el-button>
                        <el-button type="text" @click="addCate(2,items.id)">添加二级分类</el-button>
                        <el-button type="text" style='color: black;'>文件数量: {{items.count}}</el-button>
                    </div>
                    <ul class="child">
                        <li v-for="item in items.child">
                            <span class="left num">{{item.name}}</span>
                            <span class="right" @click="del(item.id)">删除</span>
                            <span class="right" @click="edit(item.id)">修改</span>
                            <span class="right num">文件数量: {{item.count}}</span>
                        </li>
                    </ul>
                </li>
            </ul>
            <el-button v-if="this.$route.query.type" type="primary" style="margin-left: 30px;" @click="$router.back(-1)">返回</el-button>
        </el-col>

        <addCateDialog
                v-if="addCateDialogVisable"
                v-on:handleClose = 'addCateDialogVisable = false'
                @refresh="getList"
                :type="type"
                :pId="pId"
                :editId="editId">
        </addCateDialog>
    </div>
</template>

<script>
    import addCateDialog from './addCateDialog'
    export default {
        name: "announcement-cate",
        data() {
            return {
                addCateDialogVisable:false,
                cateData:[],
                type:-1,
                pId:0,
                editId:0
            }
        },
        methods:
            {
                getList(){
                    this.$get('logistics', '/categories', {
                        lang:'',
                       type:1
                    }).then(res => {
                        this.cateData = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                addCate(type,pId){
                    this.editId = 0;
                    this.addCateDialogVisable = true;
                    this.type= type;
                    this.pId = pId;
                },
                edit(id){
                    this.editId = id;
                    this.addCateDialogVisable = true;
                },
                del(id){
                    this.$confirm('确定要删除该分类吗？，如果该分类已经被使用则不能删除!', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let url = '/categories/' + id;
                        this.$delete('logistics',  url, {
                            lang: '',
                            _method: 'DELETE',
                            category:id
                        }).then(res => {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.getList();
                        }).catch(error => {
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });

                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }
            },
        created() {
            this.getList();
        },
        components:{
            addCateDialog
        }
    }
</script>

<style lang="scss" scoped>
    .parent {
        background-color: #fff;
        li {
            padding: 20px 80px;
            div {
                padding-left: 20px;
                height: 50px;
                line-height: 50px;
                border: 1px solid #ccc;
                span {
                    float: left;
                }
                .el-button {
                    line-height: 26px;
                    float: right;
                    margin-right: 20px;
                }
            }
            .child {
                margin-left: 40px;
                margin-top: 10px;
                li {
                    padding-left: 20px;
                    padding-right: 20px;
                    height: 2px;
                    margin-bottom: 4px;
                    line-height: 2px;
                    border: 1px solid #ccc;
                    span{
                        font-size: 14px;
                        color:#008072;
                    }
                    .num{
                        color:black;
                    }
                    .left {
                        float: left;
                    }
                    .right {
                        float: right;
                        cursor: pointer;
                        margin-left: 20px;
                    }
                }
            }
        }
    }

</style>